import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import api from '../../services/api';

/**
 * Wrapper that redirects free_product users to their single product.
 * If the user is NOT free_product, renders children as normal.
 * If they ARE free_product, fetches their product and redirects.
 */
const FreeProductRedirect = ({ children }) => {
  const { organization, loading: authLoading } = useAuth();
  const isFreeProduct = organization?.account_type === 'free_product';
  const [productId, setProductId] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isFreeProduct || authLoading) return;
    
    const fetchProduct = async () => {
      try {
        const res = await api.get('/api/products');
        const products = res.data?.products || res.data || [];
        const active = products.filter(p => !p.archived_at);
        if (active.length > 0) {
          setProductId(active[0].product_id);
        }
      } catch (err) {
        console.error('Failed to fetch products for redirect:', err);
      } finally {
        setChecked(true);
      }
    };
    fetchProduct();
  }, [isFreeProduct, authLoading]);

  if (authLoading) return null;
  if (!isFreeProduct) return children;

  // Still checking for product
  if (!checked) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#030303]">
        <Loader2 className="w-6 h-6 animate-spin text-gray-500" />
      </div>
    );
  }

  // Has a product — redirect to it
  if (productId) {
    return <Navigate to={`/products/${productId}`} replace />;
  }

  // No product yet — send to wizard
  return <Navigate to="/products/new" replace />;
};

export default FreeProductRedirect;
